// extracted by css-extract-rspack-plugin
export default {"badgeContainer":"OqX6M4_O","medium":"x7JjfpZt","selectedContainer":"WxeEZunY"};